import { STAGE_LABELS } from '../../shared/stages.mjs';
/** Shared semantic tones; actual color values belong to the UI theme. */
export const STAGE_TONES = Object.freeze({
  RECOMMENDED: 'neutral', REQUESTED: 'neutral', DISCUSSING: 'neutral', PREPARING: 'warning',
  SENT: 'info', PROCUREMENT: 'info', DELIVERING: 'success', COMPLETED: 'success',
  NOT_PROCEEDING: 'danger', CANCELLED: 'danger', ACTIVE: 'success',
});
export function stagePresentation(stage) {
  return { label: STAGE_LABELS[stage] || (stage === 'ACTIVE' ? 'Aktif' : stage || 'Henüz talep yok'), tone: STAGE_TONES[stage] || 'neutral' };
}
